import type { MarcacaoFacial } from "@bookdental/schemas";
import type { MarcacaoDeOutroItem } from "@/components/face/EditorDaFace";
import { COR_NEUTRA } from "../cores-do-plano";

type ItemComMarcacoes = {
  id: string;
  nome: string;
  feitoEm: Date | string | null;
  offeredService: { color: string | null } | null;
  marcacoes: MarcacaoFacial[];
};

/**
 * As marcações já salvas no plano, na cor de cada procedimento — o equivalente de
 * `condicoesDoPlano` pra face. O item em edição fica de fora (ele está na montagem); com um item
 * destacado, ele fica forte e o resto apaga.
 */
export function marcacoesDoPlano(itens: ItemComMarcacoes[], destacadoId: string | null, editandoId: string | null): MarcacaoDeOutroItem[] {
  return itens
    .filter((i) => i.id !== editandoId)
    .flatMap((i) =>
      i.marcacoes.map((m) => ({
        itemId: i.id,
        nome: i.nome,
        cor: i.offeredService?.color || COR_NEUTRA,
        m,
        estilo: destacadoId ? (i.id === destacadoId ? ("destaque" as const) : ("apagada" as const)) : ("normal" as const),
      })),
    );
}
